var map = {
	"./Close-2.JPG": 186,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (1).jpeg": 187,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (12).jpeg": 188,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (14).jpeg": 189,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (15).jpeg": 190,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (16).jpeg": 191,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (20).jpeg": 192,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (21).jpeg": 193,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (3).jpeg": 194,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (6).jpeg": 195,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (9).jpeg": 196,
	"./WhatsApp Image 2021-02-23 at 22.49.29.jpeg": 197,
	"./_Collage.png": 198,
	"./why-3_.jpg": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;